export default "__VITE_PUBLIC_ASSET__102edecc__"